import React from "react";

interface ListItemCardProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * A card component for displaying items in a list.
 * Used for API keys, settings items, and other list-based content.
 */
export function ListItemCard({ children, className = "" }: ListItemCardProps) {
  return (
    <div
      className={`rounded-lg border border-border bg-card p-4 flex flex-row justify-between items-center shadow-sm ${className}`}
    >
      {children}
    </div>
  );
}

